import { render, staticRenderFns } from "./ProgramItems.vue?vue&type=template&id=935778da&scoped=true"
import script from "./ProgramItems.vue?vue&type=script&lang=js"
export * from "./ProgramItems.vue?vue&type=script&lang=js"
import style0 from "./ProgramItems.vue?vue&type=style&index=0&id=935778da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935778da",
  null
  
)

export default component.exports